import React, { useState } from "react";
import { IDataSource, MultipleSourcesSelectorInputProps, SourceSelectorInputProps } from "@types";
import { DataSourceBrowserModal } from "@components/DataSourceBrowser/DataSourceBrowserModal";
import { Select } from "uxp/components";
import { hasHistoryEnabledForSource, isDataSource } from "@utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isSourceConfigurable, ParamsEditor } from "@components/QueryEditor/ParamEditor";
import './SourceSelectorInput.scss'

export const SourceSelectorInput: React.FC<SourceSelectorInputProps> = (props) => {

    const { source, onChange, availableSources, history, query } = props;
    const [show, setShow] = useState(false);

    function filterSources() {
        if (history) {
            const _sources = (availableSources || [])?.filter(s => (isDataSource(s) && hasHistoryEnabledForSource(s)))
            return _sources || []
        }
        return availableSources || []
    }

    function getAvailableSourceOptions() {
        const _sources = filterSources()?.map((s, i) => ({ label: s.name, value: s.id, source: s }))
        _sources.push({ label: '+ Add new source', value: '__new__', source: null })

        return _sources || []
    }

    function handleSourceSelect(option: any) {
        onChange(option);
        setShow(false);
    }

    function handleOnChange(value: string, option: any) {
        if (value == '__new__') {
            setShow(true)
            return
        }
        handleSourceSelect(option.source)
    }

    return (
        <div className='lqe_sourceselctor'>
            <div className='lqe_sourceselctor-input'>
                <Select
                    selected={source?.id}
                    onChange={handleOnChange}
                    options={getAvailableSourceOptions()}
                />

                {!!source && isDataSource(source) && isSourceConfigurable(source).isConfigurable
                    ? <ParamsEditor
                        source={source as IDataSource}
                        onChange={onChange}
                        query={query}
                    />
                    : null
                }

            </div>

            <DataSourceBrowserModal
                show={show}
                onClose={() => setShow(false)}
                showCloseButton={true}
                source={source as IDataSource}
                onSelect={s => { handleSourceSelect(s) }}
                history={history}
                configuredSources={query?.sources?.filter?.(s => Object.keys(s?.params || {})?.length > 0) || []}
                query={query}
            />
        </div>
    );
}

export const MultipleSourcesSelectorInput: React.FC<MultipleSourcesSelectorInputProps> = (props) => {

    const { sources, onChange, availableSources, query } = props;

    function addSource() {
        onChange([...sources, availableSources?.[0]]);
    }

    function removeSource(index: number) {
        const newSources = [...sources];
        newSources.splice(index, 1);
        onChange(newSources);
    }

    return (
        <div className='lucy-query-engine-data-source-selector'>
            <div className="query-engine-sources-container">

                {sources.map((source, index) => (
                    <div className="query-engine-sources-input">

                        <SourceSelectorInput
                            key={index}
                            source={source}
                            onChange={(newSource) => {
                                const newSources = [...sources];
                                newSources[index] = newSource;
                                onChange(newSources);
                            }}
                            availableSources={availableSources}
                            query={query}
                        />
                        <div className='query-editor-sort-condition-remover' onClick={() => removeSource(index)}>
                            <FontAwesomeIcon icon={['fas', 'times']} />
                        </div>
                    </div>
                ))}
            </div>
            <div className='query-editor-add-source ' onClick={addSource}>+ Add source</div>
        </div>
    );
}